import styled from 'styled-components';

export const SubscriptionCancelSurveyInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 16px;
`;

export const SubscriptionCancelSurveyText = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;

  color: #5b5b5b;
`;

export const SubscriptionCancelSuccess = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 40px;
  text-align: center;

  .info {
    color: #5b5b5b;
  }
`;

export const CancelSubscriptionModalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
`;

export const CancelSubscriptionModalWrapper = styled.div`
  .trash-icon {
    margin-bottom: 25px;
  }

  .pause-icon {
    color: #f9de33;
    font-size: 65px;
    margin-bottom: 25px;
  }

  .play-icon {
    color: #26b183;
    font-size: 65px;
    margin-bottom: 25px;
  }

  .first-step-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .first-step-btn {
    margin-top: 20px;
  }

  .reason-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .reason-list {
    padding: 0;
    margin: 0 0 10px 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .custom-radio {
    display: block;
    position: relative;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    color: #1d201f;
    padding-left: 31px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    span {
      position: absolute;
      top: 0;
      left: 0;
      height: 18px;
      width: 18px;
      border-radius: 50%;
      border: 1px solid #c1c1c1;
    }

    span:after {
      content: '';
      position: absolute;
      display: none;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: #177590;
    }

    input:checked ~ span {
      border: 1px solid #177590;
    }

    input:checked ~ span:after {
      display: block;
    }
  }

  .loader-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
  }

  .loader-spinner {
    margin-bottom: 20px;
  }

  .finish-step-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    ion-icon {
      color: #26b183;
      font-size: 65px;
      margin-bottom: 10px;
    }

    .cancel-text {
      margin-bottom: 20px;
    }
  }
`;

export const SubscriptionActionModalTitle = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  color: #1d201f;
`;

export const SubscriptionActionModalText = styled.h3`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #1d201f;

  b {
    font-weight: 600;
  }
`;

export const CancelSubscriptionButton = styled.button`
  outline: none;
  border: none;
  width: fit-content;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: #5b5b5b;
  margin-top: 20px;

  &:disabled {
    color: #c1c1c1;
  }
`;
